import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';



import 'reflect-metadata';
import { AppComponent } from './app.component';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { SideNavItemComponent } from './side-nav-item/side-nav-item.component';
import { SupportRequestComponent } from './support-request/support-request.component';
import { SupportRequestService } from './support-request.service';
import { SystemGlobalsService } from './system-globals.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SettingsModule } from './settings/settings.module';
import { SharedModule } from './shared/shared.module';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { ToastModule } from 'ng-uikit-pro-standard';
import { AuthModule } from './auth/auth.module';
import { ClipboardModule } from 'ngx-clipboard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SelectControlComponent } from './common/select-control/select-control.component';

import {LearningCenterService} from "./learning-center.service";
import { ContentComponent } from './content/content.component';
import {ElementsModule} from "./common/elements/elements.module";
import { StoreComponent } from './store/store.component';
import { AiChatModule } from './ai-chat/ai-chat.module';
import { CrmModule } from './crm/crm.module';


@NgModule({
  declarations: [
    AppComponent,
    TopMenuComponent,
    SideNavComponent,
    SideNavItemComponent,
    SupportRequestComponent,
    PageNotFoundComponent,
    SelectControlComponent,
    ContentComponent,
    StoreComponent

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MDBBootstrapModulesPro.forRoot(),
    ToastModule.forRoot(),
    SharedModule,
    SettingsModule,
    AuthModule,
    ClipboardModule,
    ElementsModule,
    AiChatModule,
    CrmModule

  ],
  providers: [
    SupportRequestService,
    SystemGlobalsService,
    LearningCenterService
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
